// Shared date/time helpers for the cockpit UI.

// Format an ISO datetime (from the backend) as a concise day + time, e.g. "Jun 14, 3:21 PM".
// Returns '' for a missing/invalid value so nothing renders. Backend timestamps are UTC; if the
// string carries no timezone we treat it as UTC ('Z') so the local-time conversion is correct.
export const fmtTimestamp = (iso?: string | null): string => {
  if (!iso) return '';
  const normalized = iso.endsWith('Z') || iso.includes('+') ? iso : iso + 'Z';
  const d = new Date(normalized);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};
